class FormInputsFilling {
  constructor(elements, classes) {
    this.elements = {
      input: elements.input,
      label: elements.label
    }
    this.classes = {
      filled: classes.filled
    }
    this.value = null

    this.init()
  }

  focusEvent(event) {
    this.value = event.currentTarget.value

    if (!this.value) {
      this.elements.label.classList.add(this.classes.filled)
    }
  }

  focusCheck() {
    if (this.elements.input) {
      if (this.elements.input.value) {
        this.elements.label.classList.add(this.classes.filled)
      }
    }
  }

  blurEvent(event) {
    this.value = event.currentTarget.value

    if (!this.value) {
      this.elements.label.classList.remove(this.classes.filled)
    }
  }

  defineEvents() {
    if (this.elements.input) {
      this.elements.input.addEventListener('focus', this.focusEvent.bind(this))
      this.elements.input.addEventListener('blur', this.blurEvent.bind(this))
    }
  }

  init() {
    this.focusCheck()
    this.defineEvents()
  }
}

const formUpdateEl = document.querySelector('.form-update')
if (formUpdateEl) {
  const labelNodeList = formUpdateEl.querySelectorAll('label')

  labelNodeList.forEach(label => {
    const wrap = label.closest('.form-update__item')
    const input = wrap.querySelector('input') || wrap.querySelector('textarea')
    if (input) {
      new FormInputsFilling({
        input: input,
        label: label
      },
      {
        filled: 'filled'
      })
    }
  })
}

const blogSearchForm = document.querySelectorAll('.blog-search__form')
blogSearchForm.forEach(form => {
  const labelEl = form.querySelector('label')

  if (labelEl) {
    const wrap = labelEl.closest('form')
    const input = wrap.querySelector('input') || wrap.querySelector('textarea')
    if (input) {
      new FormInputsFilling({
        input: input,
        label: labelEl
      },
      {
        filled: 'filled'
      })
    }
  }
})